import { defineMessages } from '@kyruus/intl';

export const messages = defineMessages({
  additionalInfo: {
    id: 'location.profile.additionalInfo',
    description: 'additional info section heading',
    defaultMessage: 'Additional Info'
  }
});
